<template>
  <router-view />
</template>

<script>
export default {
  name: "app-statistic"
};
</script>

<style lang="scss" scoped></style>
